import { memo } from "react";

const MarkAsReadIcon = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6933 6.27709C14.0202 6.60107 14.0226 7.1287 13.6986 7.45559L11.0086 10.1698C10.6846 10.4966 10.157 10.499 9.83007 10.175C9.50318 9.85105 9.50082 9.32342 9.8248 8.99653L12.5148 6.28236C12.8388 5.95547 13.3664 5.95311 13.6933 6.27709ZM17.8617 6.27969C18.1872 6.60511 18.1872 7.13274 17.8618 7.4582L10.7918 14.529C10.6355 14.6853 10.4236 14.7731 10.2025 14.7731C9.98152 14.7732 9.76955 14.6854 9.61327 14.5291L6.07743 10.9932C5.75199 10.6678 5.75199 10.1402 6.07743 9.81472C6.40287 9.48928 6.93051 9.48928 7.25594 9.81472L10.2025 12.7613L16.6832 6.27976C17.0086 5.9543 17.5363 5.95427 17.8617 6.27969ZM1.91076 9.81472C2.2362 9.48928 2.76384 9.48928 3.08928 9.81472L6.62511 13.3506C6.95055 13.676 6.95055 14.2036 6.62511 14.5291C6.29967 14.8545 5.77204 14.8545 5.4466 14.5291L1.91076 10.9932C1.58533 10.6678 1.58533 10.1402 1.91076 9.81472Z"
      fill="#8E33FF"
    />
  </svg>
);
export default memo(MarkAsReadIcon);
